"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Tableau Services APIs
 * Open API specification for Tableau Services APIs
 *
 * The version of the OpenAPI document: latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
const _1 = require("./");
function TableauQuerygatewayV1ConnectionDetailsFromJSON(json) {
    return TableauQuerygatewayV1ConnectionDetailsFromJSONTyped(json, false);
}
exports.TableauQuerygatewayV1ConnectionDetailsFromJSON = TableauQuerygatewayV1ConnectionDetailsFromJSON;
function TableauQuerygatewayV1ConnectionDetailsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'allowCustomSql': !runtime_1.exists(json, 'allow_custom_sql') ? undefined : json['allow_custom_sql'],
        'allowCustomSqlWithoutSchema': !runtime_1.exists(json, 'allow_custom_sql_without_schema') ? undefined : json['allow_custom_sql_without_schema'],
        'allowCustomDatabase': !runtime_1.exists(json, 'allow_custom_database') ? undefined : json['allow_custom_database'],
        'allowStoredProc': !runtime_1.exists(json, 'allow_stored_proc') ? undefined : json['allow_stored_proc'],
        'allowCustomSchema': !runtime_1.exists(json, 'allow_custom_schema') ? undefined : json['allow_custom_schema'],
        'hasWarehouse': !runtime_1.exists(json, 'has_warehouse') ? undefined : json['has_warehouse'],
        'hasDatabase': !runtime_1.exists(json, 'has_database') ? undefined : json['has_database'],
        'hasSchema': !runtime_1.exists(json, 'has_schema') ? undefined : json['has_schema'],
        'hasTables': !runtime_1.exists(json, 'has_tables') ? undefined : json['has_tables'],
        'databaseName': !runtime_1.exists(json, 'database_name') ? undefined : json['database_name'],
        'schemaName': !runtime_1.exists(json, 'schema_name') ? undefined : json['schema_name'],
        'warehouseName': !runtime_1.exists(json, 'warehouse_name') ? undefined : json['warehouse_name'],
        'databaseOptional': !runtime_1.exists(json, 'database_optional') ? undefined : json['database_optional'],
        'databaseWhOptional': !runtime_1.exists(json, 'database_wh_optional') ? undefined : json['database_wh_optional'],
        'schemaOptional': !runtime_1.exists(json, 'schema_optional') ? undefined : json['schema_optional'],
        'allowRandomSampling': !runtime_1.exists(json, 'allow_random_sampling') ? undefined : json['allow_random_sampling'],
        'hasIntegratedAuth': !runtime_1.exists(json, 'has_integrated_auth') ? undefined : json['has_integrated_auth'],
        'hasOauth': !runtime_1.exists(json, 'has_oauth') ? undefined : json['has_oauth'],
        'supportOutputInPrep': !runtime_1.exists(json, 'support_output_in_prep') ? undefined : json['support_output_in_prep'],
        'connectionTypeLabel': !runtime_1.exists(json, 'connection_type_label') ? undefined : json['connection_type_label'],
        'connectionDescriptionLabel': !runtime_1.exists(json, 'connection_description_label') ? undefined : json['connection_description_label'],
        'tableEnumeration': !runtime_1.exists(json, 'table_enumeration') ? undefined : _1.TableauQuerygatewayV1TableEnumerationFromJSON(json['table_enumeration']),
        'databaseEnumeration': !runtime_1.exists(json, 'database_enumeration') ? undefined : _1.TableauQuerygatewayV1DatabaseEnumerationFromJSON(json['database_enumeration']),
        'schemaEnumeration': !runtime_1.exists(json, 'schema_enumeration') ? undefined : _1.TableauQuerygatewayV1SchemaEnumerationFromJSON(json['schema_enumeration']),
        'standardConnectionEnumeration': !runtime_1.exists(json, 'standard_connection_enumeration') ? undefined : _1.TableauQuerygatewayV1StandardConnectionEnumerationFromJSON(json['standard_connection_enumeration']),
        'storedProcedureEnumeration': !runtime_1.exists(json, 'stored_procedure_enumeration') ? undefined : _1.TableauQuerygatewayV1StoredProcedureEnumerationFromJSON(json['stored_procedure_enumeration']),
        'warehouseEnumeration': !runtime_1.exists(json, 'warehouse_enumeration') ? undefined : _1.TableauQuerygatewayV1WarehouseEnumerationFromJSON(json['warehouse_enumeration']),
    };
}
exports.TableauQuerygatewayV1ConnectionDetailsFromJSONTyped = TableauQuerygatewayV1ConnectionDetailsFromJSONTyped;
function TableauQuerygatewayV1ConnectionDetailsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'allow_custom_sql': value.allowCustomSql,
        'allow_custom_sql_without_schema': value.allowCustomSqlWithoutSchema,
        'allow_custom_database': value.allowCustomDatabase,
        'allow_stored_proc': value.allowStoredProc,
        'allow_custom_schema': value.allowCustomSchema,
        'has_warehouse': value.hasWarehouse,
        'has_database': value.hasDatabase,
        'has_schema': value.hasSchema,
        'has_tables': value.hasTables,
        'database_name': value.databaseName,
        'schema_name': value.schemaName,
        'warehouse_name': value.warehouseName,
        'database_optional': value.databaseOptional,
        'database_wh_optional': value.databaseWhOptional,
        'schema_optional': value.schemaOptional,
        'allow_random_sampling': value.allowRandomSampling,
        'has_integrated_auth': value.hasIntegratedAuth,
        'has_oauth': value.hasOauth,
        'support_output_in_prep': value.supportOutputInPrep,
        'connection_type_label': value.connectionTypeLabel,
        'connection_description_label': value.connectionDescriptionLabel,
        'table_enumeration': _1.TableauQuerygatewayV1TableEnumerationToJSON(value.tableEnumeration),
        'database_enumeration': _1.TableauQuerygatewayV1DatabaseEnumerationToJSON(value.databaseEnumeration),
        'schema_enumeration': _1.TableauQuerygatewayV1SchemaEnumerationToJSON(value.schemaEnumeration),
        'standard_connection_enumeration': _1.TableauQuerygatewayV1StandardConnectionEnumerationToJSON(value.standardConnectionEnumeration),
        'stored_procedure_enumeration': _1.TableauQuerygatewayV1StoredProcedureEnumerationToJSON(value.storedProcedureEnumeration),
        'warehouse_enumeration': _1.TableauQuerygatewayV1WarehouseEnumerationToJSON(value.warehouseEnumeration),
    };
}
exports.TableauQuerygatewayV1ConnectionDetailsToJSON = TableauQuerygatewayV1ConnectionDetailsToJSON;
